import AppLink from '@/components/common/AppLink';
import MainIcons from '@/icons/main';
import styles from './styles.module.css';
import { usePathname, useSearchParams } from 'next/navigation';
import { cloneElement, Fragment, isValidElement, ReactElement, ReactNode, SVGProps } from 'react';

export type ToggleType = 'products' | 'services' | 'shops';

export interface MenuItemType {
  id?: number | string;
  title?: string;
  href?: string;
  icon?: ReactElement<SVGProps<SVGSVGElement>>;
  onClick?: (() => void) | null;
  count?: string | number;
}

export default function MenuToggle({
  type = 'link',
  data,
  activeId,
  className = '',
  activeStyle = '',
}: {
  type?: 'link' | 'button';
  className?: string;
  data?: MenuItemType[];
  activeId?: number | string | null;
  activeStyle?: string;
}) {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const fullPath = `${pathname}?${searchParams.toString()}`;
  const list: MenuItemType[] = data
    ? data
    : [
        {
          id: 1,
          title: 'محصولات',
          href: '/products',
          icon: <MainIcons.basketIcon width="15px" height="15px" />,
          onClick: null,
        },
        {
          id: 2,
          title: 'سرویس‌ها',
          href: '/shop-services',
          icon: <MainIcons.carIcon width="15px" height="15px" />,
          onClick: null,
        },
        {
          id: 3,
          title: 'فروشگاه‌ها',
          href: '/shops',
          icon: <MainIcons.shopIcon width="15px" height="15px" />,
          onClick: null,
        },
      ];
  const renderItem = (item: MenuItemType) => (
    <>
      {item?.icon &&
      item?.href &&
      isValidElement(item?.icon as React.ReactElement<React.SVGProps<SVGSVGElement>>)
        ? cloneElement(item?.icon, {
            fill:
              fullPath?.includes(item?.href) || item?.id == activeId
                ? 'var(--paper)'
                : 'var(--text-mut2)',
            width: `${'16px'}`,
            height: `${'16px'}`,
          })
        : item?.icon}
      {item?.title}
      {item?.count && <span className={`${styles.count}`}>{item?.count}</span>}
    </>
  );
  console.log('activeId==========', activeId, list, fullPath, list?.[0]?.id);
  return (
    <div className={`${styles.container} ${className}`}>
      {list?.map((item, index) => (
        <Fragment key={index}>
          {type == 'link' && item?.href ? (
            <AppLink
              href={item?.href}
              title={item?.title}
              className={`${styles.item} ${(fullPath?.includes(item?.href) || item?.id == activeId) && `${styles.active} ${activeStyle}`}`}
            >
              {renderItem(item)}
            </AppLink>
          ) : (
            <div
              className={`${styles.item} ${item?.id == activeId && `${styles.active} ${activeStyle}`}`}
              onClick={() => {
                item?.onClick && item?.onClick();
              }}
            >
              {renderItem(item)}
            </div>
          )}
        </Fragment>
      ))}
    </div>
  );
}
